// Module
var code = `<div>
    <app-card-detail-add
            [props]="cardProps"
            [addressDisabled]="prefillAddressForm !== UNSELECTED || true"
            [cardDisabled]="true"
            [showNickName]="true"
            (onFormComplete)="onCardValid(\$event)">
    </app-card-detail-add>
    <div class="HOA-container__content-hrule HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--100 u-mT5"></div>
    <app-card-address
            [props]="addressProps"
            (addressFormValidate)="onAddressValid(\$event)" >
    </app-card-address>
    <div class="HOA-Card-Add-button-container">
        <button type="button" class="Button Button--link" (click)="onCancel()">
            Cancel
        </button>
        <button type="button" class="Button Button--blue" [disabled]="!cardFormValid || !addressFormValid" (click)="preSubmit()">
            Add Card
        </button>
    </div>
    <div class="u-pT2 HOA-font-fine-print"><span class="asterisk-required">&#42;</span>&nbsp;Indicates required field</div>
</div>`;
// Exports
module.exports = code;